import { SET_NEXT_RESERVATIONS } from './../actions/setNextReservationsByRestaurantId';
import { SET_NEW_STATE_TO_RESERVE } from './../actions/setNewStateToReserve';

export const nextReservations = (state = {}, action) => {
    switch(action.type) {
        case SET_NEXT_RESERVATIONS: {
            return action.payload;
        }
        case SET_NEW_STATE_TO_RESERVE:
            const { id, newState, isLoading } = action.payload;
            return { ...state, [id]: { ...state[id], state: newState, isLoading: isLoading } };
        default:
            return state;
    }
}